<template>
    <p-secure :require-role="[SECURITYROLES.STOREMANAGER]">
        <div class="container-fluid content-wrapper">
            <b-row class="content-heading">
                <b-col>
                    <div>Buyback - Buyers</div>
                </b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col class="d-flex align-items-center gap-2">
                    <editbuyer
                        class="pb-2 ms-3 me-2"
                        buyer-id="new"
                        @data-saved="updateBuyerSearch()"
                    />
                    <editbuyergroup
                        class="pb-2"
                        group-id="new"
                        @data-saved="updateGroupSearch()"
                    />
                </b-col>
            </b-row>
            <b-tabs justified>
                <b-tab title="Buyback Buyers">
                    <p-search-table
                        :fields="buyerFields"
                        ref="buyerSearch"
                        :selectable="false"
                        :enable-row-selection="false"
                        search-destination="buyers"
                        sort-by="name"
                        api-destination="buyback"
                    >
                        <template v-slot:cell(edit)="{ value, item }">
                            <b-button
                                size="sm"
                                variant="outline-primary"
                                @click="openBuyerEdit(item.buybackBuyerId)"
                            >Edit</b-button>
                        </template>
                        <template v-slot:cell(fastEndTransaction)="{ value, item }">
                            <p-checkbox
                                disabled
                                v-model="item.fastEndTransactions"
                            />
                        </template>
                    </p-search-table>
                </b-tab>
                <b-tab title="Buyback Groups">
                    <p-search-table
                        :fields="groupFields"
                        ref="groupSearch"
                        :selectable="false"
                        :enable-row-selection="false"
                        search-destination="groups"
                        sort-by="description"
                        api-destination="buyback"
                    >
                        <template v-slot:cell(edit)="{ value, item }">
                            <b-button
                                size="sm"
                                variant="outline-primary"
                                @click="openGroupEdit(item.buybackBuyerGroupId)"
                            >Edit</b-button>
                        </template>
                    </p-search-table>
                </b-tab>
            </b-tabs>

            <!-- One shared edit instance for the currently-clicked row. Only
                 mounts when a buyer/group is being edited, then unmounts after.
                 Avoids paying the cost of N EditBuyer mounts per page. -->
            <editbuyer
                v-if="editingBuyerId"
                ref="sharedBuyerEdit"
                :buyer-id="editingBuyerId"
                @data-saved="updateBuyerSearch()"
            />
            <editbuyergroup
                v-if="editingGroupId"
                ref="sharedGroupEdit"
                :group-id="editingGroupId"
                @data-saved="updateGroupSearch()"
            />
        </div>
    </p-secure>
</template>

<script>
import editbuyer from '@/views/Buyback/EditBuyer.vue';
import editbuyergroup from '@/views/Buyback/EditBuyerGroup.vue';

export default {
    components: { editbuyer, editbuyergroup},
    props: {
        id: String
    },
    data() {
        return {
            editingBuyerId: null,
            editingGroupId: null,
            buyerFields: [
                {
                    key: 'edit',
                    label: '',
                    class: 'tcw100'
                },
                {
                    key: 'name',
                    sortable: true
                },
                {
                    key: 'loginId',
                    sortable: true
                },
                {
                    key: 'buyerGroup',
                    sortable: true
                },
                {
                    key: 'fastEndTransaction',
                    label: 'Fast End Trans.'
                }
            ],
            groupFields: [
                {
                    key: 'edit',
                    label: '',
                    class: 'tcw100'
                },
                {
                    key: 'description',
                    label: 'Group',
                    sortable: true
                },
                {
                    key: 'priorityLocation',
                    sortable: true
                }
            ]
        };
    },
    watch: {
        $route: function(to, from) {
            if (to !== from) {
                this.loadData();
            }
        }
    },
    methods: {
        updateBuyerSearch() {
            this.$refs?.buyerSearch.refreshSearchResults();
        },
        updateGroupSearch() {
            this.$refs?.groupSearch.refreshSearchResults();
        },
        openBuyerEdit(id) {
            this.editingBuyerId = id;
            this.$nextTick(() => {
                this.$refs.sharedBuyerEdit?.$refs?.editBuyerModal?.show?.();
            });
        },
        openGroupEdit(id) {
            this.editingGroupId = id;
            this.$nextTick(() => {
                this.$refs.sharedGroupEdit?.$refs?.editBuyerGroupModal?.show?.();
            });
        }
    }
};
</script>
<style scoped lang="scss">
@import "@/styles/app/common/variables.scss";
:deep(.tcw100 ) {
    width: 100px;
}

:deep(.table-responsive ) {
    overflow-x: hidden;
}
</style>
